import React, { useState } from 'react';
import styles from './style.module.scss';
import Image from 'next/image';
import Button, { SECONDARY_THEME } from 'components/control/button';
import Link from 'components/link';
import { buildClassName } from 'utils/build-class-name';
import PowerOfExpModal from 'components/modal-dialog/power-of-exp';
import { useIsMobile } from 'hooks/use-size-class';
import { useTranslation } from 'next-i18next';
import { PowerOfExpData } from '@tenants/types/tenant';

export const EXP_HASHTAG = '#eXpExplained';

type PowerOfExpProps = {
  powerOfExpData: PowerOfExpData;
  onSignMeUpClick: () => void;
  onGetNowClick: () => void;
};

function PowerOfExp({ powerOfExpData, onSignMeUpClick, onGetNowClick }: PowerOfExpProps) {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => {
    onGetNowClick();
    setIsModalOpen(true);
  };
  const handleCloseModal = () => setIsModalOpen(false);
  const isMobile = useIsMobile();
  const secondSectionHeading = isMobile ? powerOfExpData.section2.title.mobile : powerOfExpData.section2.title.desktop;
  const secondSectionButtonLabel = isMobile ? powerOfExpData.section2.button.mobile : powerOfExpData.section2.button.desktop;

  return (
    <div className={styles.component}>
      <h1 className={styles.heading}>
        {t(powerOfExpData.title)}
      </h1>

      <div className={buildClassName(styles['two-column-layout'], styles['first-layout'])}>
        <div className={styles['left-column']}>
          <div className={styles['image-wrapper']}>
            <Image 
              src={t(powerOfExpData.section1.image)}
              alt={t(powerOfExpData.section1.imageAlt)}
              width={273}
              height={322}
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
          { !isMobile && <div className={styles.number}>01</div> }
        </div>
        <div className={styles['right-column']}>
          { isMobile && <div className={styles.number}>01</div> }
          <h3 className={styles.title}>{t(powerOfExpData.section1.title)}</h3>
          <p className={styles.info}>{t(powerOfExpData.section1.info)}</p>
          <p className={styles.timing}>{t(powerOfExpData.section1.timing)}</p>
          <p className={styles.note}>{t(powerOfExpData.expExplainedHashtag)}</p>
          <Link onClick={onSignMeUpClick} href={t(powerOfExpData.section1.signMeUpHref)} target='_blank' rel='noopener noreferrer'>
            <Button className={styles.button} label={t(powerOfExpData.section1.button)} theme={SECONDARY_THEME} />
          </Link>
        </div>
      </div>

      <div className={styles['two-column-layout']}>
        <div className={styles['left-column']}>
          <div className={styles['image-wrapper']}>
            <Image 
              src={t(powerOfExpData.section2.image)}
              alt={t(powerOfExpData.section2.imageAlt)}
              width={273}
              height={322}
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
          { !isMobile && <div className={styles.number}>02</div> }
        </div>
        <div className={styles['right-column']}>
          { isMobile && <div className={styles.number}>02</div> }
          <h3 className={styles.title}>{t(secondSectionHeading)}</h3>
          <p className={styles.info}>{t(powerOfExpData.section2.info)}</p>
          <p className={styles.note}>{t(powerOfExpData.expExplainedHashtag)}</p>
          <Button className={styles.button} label={t(secondSectionButtonLabel)} theme={SECONDARY_THEME} onClick={handleOpenModal} />
          {isModalOpen && <PowerOfExpModal 
            onClose={handleCloseModal} 
            powerOfExpData={powerOfExpData}

          />}
        </div>
      </div>
    </div>
  );
}

export default PowerOfExp;